import React from 'react';
import { Link } from 'react-router-dom';
import AuthUserContext from './AuthUserContext';
import SignOutButton from './SignOut';
import * as routes from '../constants/routes';
import './Navigation.css';

//    <li><Link to={routes.HOME}>Home</Link></li>

// https://stackoverflow.com/questions/41466055/how-do-i-pass-state-through-react-router
// https://www.robinwieruch.de/complete-firebase-authentication-react-tutorial/#react-firebase-password
  const Navigation = () =>
    <AuthUserContext.Consumer>
      {authUser => authUser
        ? <NavigationAuth />
        : <NavigationNonAuth />
      }
    </AuthUserContext.Consumer>

    const NavigationAuth = () =>
<nav >
  <ul className="topnav">

    <li><Link to={routes.LANDING}>About the Assessment</Link></li>
    <li><Link to={routes.HOME}>GDPR Questionnaire</Link></li>
    <li><Link to={routes.REPOSITORY}>GDPR Resources</Link></li>
    <li><Link to={routes.ACCOUNT}>Account Management</Link></li>
    <li  style={{marginTop: '10px'}} >
    <SignOutButton />
    </li>
    <li  >
    <div className="relative">
    <img  id="logo" src={require('./logo1.png')}  alt={"Assentian Ltd." } height={"50"} width={"200"}/>
    </div>
    </li>

  </ul>
</nav>
const NavigationNonAuth = () =>
  <nav>
  <ul className="topnav" id="myTopnav">
    <li><Link to={routes.LANDING}>About the Assessment</Link></li>
    <li><Link to={routes.SIGN_IN}>Sign In</Link></li>
    <li >
    <div className="relative">
    <img  id="logo" src={require('./logo1.png')}  alt={"Assentian Ltd." } height={"50"} width={"200"}/>
    </div>
    </li>
  </ul>
</nav>
export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Navigation.js